import TemplateView from '../../TemplateView'
import messageResource from '../../messageResource'
import Button from '../../components/Button'
import {NO_DRAG_CLASS, SUPPORT_EMAIL_NUMBER_ALLOWED_CHARACTERS, SUPPORT_INPUT_HEIGHT, SUPPORT_NUMBER_ALLOWED_CHARACTERS, supportFormMode} from './constants'
import ResizableInput from '../../panels/ResizableInput'
import {BASE_PATH} from '../../constants'
import Dropzone from 'dropzone'
import InputField from '../../components/InputField'
import {isEmailValid} from '../../atUtils'
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import {sendQuestion, setSupportAttachmentId, setSupportAttachmentName, setSupportEmail, setSupportFormMode, setSupportText} from './actions'
import {getSupportAttachmentName, getSupportEmail, getSupportFormMode, getSupportText} from './selectors'
import {hasEmail} from '../../loggedInUser/selectors'

class ContactSupportForm extends TemplateView {
    constructor({
        setFormMode = () => {},
        setText = () => {},
        setAttachmentId = () => {},
        setAttachmentName = () => {},
        setEmail = () => {},
        sendQuestion = () => {},
    }) {
        super()

        this.actions = {
            setFormMode,
            setText,
            setAttachmentId,
            setAttachmentName,
            setEmail,
            sendQuestion,
        }

        this.state = {
            hasEmail: false,
            mode: supportFormMode.EDITOR,

            text: '',
            email: '',

            attachmentName: '',
        }

        this.onStatePropertyChanged('hasEmail', (hasEmail) => {
            this.getEl().toggleClass('withContactInfo', !hasEmail)
        })

        this.onStatePropertyChanged('mode', (mode) => {
            this.$supportEditor.toggle(mode === supportFormMode.EDITOR)
            this.$success.toggle(mode === supportFormMode.SUCCESS)
        })

        this.onStatePropertyChanged('text', text => {
            this.messageInput.setState({text})

            const characterCount = text.length
            this.$supportEditor.toggleClass('textExceeded', characterCount > SUPPORT_NUMBER_ALLOWED_CHARACTERS)

            if (characterCount > SUPPORT_NUMBER_ALLOWED_CHARACTERS) {
                const exceededCharacters = characterCount - SUPPORT_NUMBER_ALLOWED_CHARACTERS
                this.$textError.text(
                    messageResource.getMessage('contact_support.main.text_exceeded', [SUPPORT_NUMBER_ALLOWED_CHARACTERS, exceededCharacters]))
            }
        })

        this.onStatePropertyChanged('email', (value) => {
            this.contactInput.setState({value})
        })

        this.onAnyStatePropertyChanged(['text', 'email', 'hasEmail'], () => {
            const email = this.state.email.trim()
            const textValid = this.state.text !== '' && this.state.text.length <= SUPPORT_NUMBER_ALLOWED_CHARACTERS
            const emailValid = this.state.hasEmail || email.length > 0 && isEmailValid(email)

            this.sendButton.setState({disabled: !textValid || !emailValid})
        })

        this.onStatePropertyChanged('attachmentName', () => {
            this.$textArea.toggleClass('hasFile', !!this.state.attachmentName)
            this.$filename.text(this.state.attachmentName)
        })
    }

    templateHtml() {
        return '<div class="contactSupportForm">' +
               '    <div class="header"/>' +
               '    <div class="supportEditor">' +
               '        <div class="title"><%=contactSupport%></div>' +
               '        <div class="textArea <%=noDragClass%>">' +
               '            <div class="inputPlaceholder"/>' +
               '            <div class="attachment">' +
               '                <div class="text"><%=dropzone%></div>' +
               '                <div class="icon"/>' +
               '            </div>' +
               '            <div class="supportDropzonePreviewTemplate dz-preview dz-file-preview">' +
               '                <div class="supportDropzonePreview dz-progress">' +
               '                    <div class="dz-upload" data-dz-uploadprogress></div>' +
               '                    <div class="dz-details">' +
               '                        <div class="dz-filename" data-dz-name></div>' +
               '                        <div class="button dz-remove" data-dz-remove></div>' +
               '                    </div>' +
               '                </div>' +
               '            </div>' +
               '        </div>' +
               '        <div class="textError"/>' +
               '        <div class="contactSection">' +
               '            <div class="title"><%=contactInformation%></div>' +
               '            <div class="contactInputPlaceholder"/>' +
               '        </div>' +
               '        <div class="sendButton <%=noDragClass%>"/>' +
               '    </div>' +
               '    <div class="success">' +
               '        <div class="title"><%=successTitle%></div>' +
               '        <div class="note"><%=successNote%></div>' +
               '        <div class="sendAgain <%=noDragClass%>"><%=sendAgain%></div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            contactSupport: 'contact_support.main.title',
            dropzone: 'contact_support.main.dropzone_placeholder',
            contactInformation: 'support.contact_information',
            successTitle: 'contact_support.success.title',
            successNote: 'contact_support.success.thank_you',
            sendAgain: 'contact_support.success.send_again',
        }
    }

    templateModel() {
        return {
            noDragClass: NO_DRAG_CLASS,
        }
    }

    afterRender() {
        this.$supportEditor = this.find('.supportEditor')
        this.$success = this.find('.success')
        this.$contactSection = this.find('.contactSection')
        this.$textArea = this.find('.textArea')
        this.$textError = this.find('.textError')
        this.$filename = this.find('.dz-details .dz-filename')
        this.$removeFileButton = this.find('.dz-details .dz-remove.button')

        this.messageInput = new ResizableInput({
            showCounter: false,
            heightLimit: SUPPORT_INPUT_HEIGHT,
            minHeight: SUPPORT_INPUT_HEIGHT,
            maxLength: SUPPORT_NUMBER_ALLOWED_CHARACTERS,
            allowInputOverMaxLength: true,
            onFocus: () => this.$textArea.addClass('active'),
            onBlur: (text) => {
                this.$textArea.removeClass('active')
                if (text !== '') {
                    this.actions.setText(text)
                }
            },
            onChange: (text) => this.actions.setText(text)
        }).init(this.find('.inputPlaceholder'))
        this.messageInput.setState({
            placeholder: messageResource.getMessage('contact_support.main.type_your_message'),
        })
        this._initDropzone()
        this.$removeFileButton.click(() => {
            this.actions.setAttachmentId(0)
            this.actions.setAttachmentName('')
        })

        this.contactInput = new InputField({
            placeholder: messageResource.getMessage('contact_support.main.enter_email'),
            maxLength: SUPPORT_EMAIL_NUMBER_ALLOWED_CHARACTERS,
            onChange: (email) => this.actions.setEmail(email),
            additionalClass: NO_DRAG_CLASS,
        }).init(this.find('.contactSection .contactInputPlaceholder'))

        this.sendButton = new Button({
            label: messageResource.getMessage('contact_support.main.send_message'),
            onClickCb: this.actions.sendQuestion
        }).init(this.find('.sendButton'))

        this.find('.sendAgain').click(() => this.actions.setFormMode(supportFormMode.EDITOR))

        this.renderInitialState()
    }

    onShow() {
        this.messageInput.focus()
    }

    _initDropzone() {
        this.dropzone = new Dropzone('.textArea', {
            previewTemplate: document.querySelector('.supportDropzonePreviewTemplate').innerHTML,
            url: BASE_PATH + 'uploadsupportfile.do',
            createImageThumbnails: false,
            maxFiles: 1,
            maxFilesize: 10,
            clickable: '.attachment .icon',
            dictMaxFilesExceeded: messageResource.getMessage('common.multiple_upload_error'),
            accept: (file, callback) => {
                if (file.size === 0)
                    callback(messageResource.getMessage('contact_support.error.empty_file'))
                else {
                    this.actions.setAttachmentName(file.name)
                    callback()
                }
            }
        })
        this.dropzone.on('addedfile', (file) => {
            //delete for compatibility - file preview must be shown on other pages
            file.previewElement.innerHTML = ''
        })
        this.dropzone.on('success', (file, response) => {
            let error = false
            try {
                response = JSON.parse(response)
                error = response.error
            } catch (e) {
                error = true
            }

            if (!error) {
                this.actions.setAttachmentId(response.result)
            } else {
                this._onDropzoneError(file, messageResource.getMessage('contact_support.error.upload'))
            }
            //delete for compatibility - file preview must be shown on other pages
            this.dropzone.removeFile(file)
        })
        this.dropzone.on('error', (file, error) => {
            if (file.xhr) {
                let httpStatus = file.xhr.status
                if (httpStatus === 0)
                    error = messageResource.getMessage('contact_support.error.http_0')
                else if (httpStatus >= 400 && httpStatus <= 499)
                    error = messageResource.getMessage('contact_support.error.http_4xx')
                else if (httpStatus >= 500)
                    error = messageResource.getMessage('contact_support.error.http_5xx')
            }

            this._onDropzoneError(file, error)
        })
        this.dropzone.on('removedfile', () => {
            this.dropzone.setupEventListeners()
        })
    }

    _onDropzoneError(file, errorText) {
        if (file.status !== 'canceled') {
            alert(errorText)
            this.dropzone.removeFile(file)
        }
    }
}

export default connect(
    state => ({
        hasEmail: hasEmail(state),
        mode: getSupportFormMode(state),
        text: getSupportText(state),
        attachmentName: getSupportAttachmentName(state),
        email: getSupportEmail(state),
    }),
    (dispatch) => ({
        setFormMode: bindActionCreators(setSupportFormMode, dispatch),
        setText: bindActionCreators(setSupportText, dispatch),
        setAttachmentId: bindActionCreators(setSupportAttachmentId, dispatch),
        setAttachmentName: bindActionCreators(setSupportAttachmentName, dispatch),
        setEmail: bindActionCreators(setSupportEmail, dispatch),
        sendQuestion: bindActionCreators(sendQuestion, dispatch),
    })
)(ContactSupportForm)



// WEBPACK FOOTER //
// ./web/js/support/supportForm/ContactSupportForm.js